<template>
  <v-layout row wrap>
    <v-flex xs4 class="pr-1">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">Analytes Measured</div>
          <div class="headline">
            {{numberWithCommas(dataSummary.analytesMeasured, 0)}}
            <v-icon>format_color_fill</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs4 class="px-1">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">From</div>
          <div class="headline">
            {{dataSummary.from}}
            <v-icon>event</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs4 class="pl-1">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">To</div>
          <div class="headline">
            {{dataSummary.to}}
            <v-icon>event</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs6 class="pt-2 pr-1">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">Measurements</div>
          <div class="headline">
            {{numberWithCommas(dataSummary.measurements, 0)}}
            <v-icon>mdi-water</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs6 class="pt-2 pl-1">
      <v-card class="max-height elevation-1">
        <v-card-text class="card-bg-1">
          <div class="caption grey--text text--darken-2">Depth/Height Measurements</div>
          <div class="headline">
            {{numberWithCommas(dataSummary.depthMeasurements, 0)}}
            <v-icon>terrain</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    numberWithCommas,
  } from '@/helpers/numbers'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import {
    getDataTimeRange,
    getTotalNumberOfRecords,
  } from '@/helpers/dataSources/discreteEnvirodata'

  import {
    prettyDateFormat,
  } from '@/components/mixins/MomentUtil'

  export default {
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData']),
      discreteData() {
        return this.currentFeatureDataSourceData(SOURCE_TYPES.discreteEnvirodata)
      },
      waterQualityData() {
        return this.discreteData && this.discreteData.wqData
      },
      dataSummary() {
        let summary = {}
        if (!this.waterQualityData) return summary

        let datasets = this.waterQualityData.WaterQualityDatasets
        summary['analytesMeasured'] = datasets.length
        let timeRange = getDataTimeRange(datasets)
        summary['from'] = timeRange[0].format(prettyDateFormat)
        summary['to'] = timeRange[1].format(prettyDateFormat)
        summary['measurements'] = getTotalNumberOfRecords(datasets)
        summary['depthMeasurements'] = this.numMeasurementsWithDepthData

        return summary
      },
    },
    methods: {
      numberWithCommas,
    },
  }
</script>